import React from 'react';
import { PromoHero } from './components/PromoHero';
export function App() {
  return <div className="min-h-screen w-full bg-black" data-id="element-0">
      <PromoHero data-id="element-1" />
    </div>;
}